import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment, useEffect, useRef, useState } from "react";
import { useBannerStylesheet } from "../../../hooks";
import { extendBannerBubbleStylesheet } from "@devowl-wp/web-cookie-banner";
import { BannerStickyIcon } from ".";
import { useBanner } from "../../../contexts";
import { AsciiSpinner, AnimatedCss } from "../..";
import { yieldMainThread } from "@devowl-wp/react-utils";
const BannerStickyBubble = ()=>{
    const { sticky: { icon, iconCustom, iconCustomRetina, animationsEnabled, hoverIconCustom, hoverIconCustomRetina }, texts: { stickyChange, stickyHistory, stickyRevoke, stickyRevokeSuccessMessage }, openBanner, openHistory, revokeConsent, previewStickyMenuOpenState = false } = useBanner();
    const { bubble, bubbleActive, bubbleMounted, menu, specify, className, screenReaderOnlyClass } = useBannerStylesheet().extend(...extendBannerBubbleStylesheet);
    specify(className);
    const [isActive, setIsActive] = useState(false);
    const [isHover, setIsHover] = useState(false);
    const [renderedOnce, setRenderedOnce] = useState(false);
    const [isRevoked, setIsRevoked] = useState(false);
    const firstLinkRef = useRef();
    const useIsActive = isActive || previewStickyMenuOpenState;
    // Calculate logo
    const useRetina = iconCustomRetina && !(iconCustom == null ? void 0 : iconCustom.endsWith(".svg")) && window.devicePixelRatio > 1;
    const useHoverRetina = hoverIconCustom && !(hoverIconCustom == null ? void 0 : hoverIconCustom.endsWith(".svg")) && window.devicePixelRatio > 1;
    const useIcon = useRetina ? iconCustomRetina : iconCustom;
    const useHoverIcon = useHoverRetina ? hoverIconCustomRetina : hoverIconCustom;
    useEffect(()=>{
        if (previewStickyMenuOpenState && !renderedOnce) {
            setRenderedOnce(true);
        }
    }, [
        renderedOnce,
        previewStickyMenuOpenState
    ]);
    const isScreenMountedRef = useRef(false);
    useEffect(()=>{
        isScreenMountedRef.current = true;
    }, []);
    return /*#__PURE__*/ _jsxs("div", {
        id: className,
        ref: (ref)=>yieldMainThread().then(()=>ref == null ? void 0 : ref.classList.add(bubbleMounted)),
        className: `${useIsActive ? bubbleActive : ""}`,
        children: [
            /*#__PURE__*/ _jsx("a", {
                href: "#",
                className: screenReaderOnlyClass,
                "aria-label": "focus",
                onFocus: (e)=>{
                    // This element is used to focus the first link in the menu
                    setRenderedOnce(true);
                    e.target.style.display = "none"; // Hide from accessibility tree
                    yieldMainThread().then(()=>firstLinkRef.current.focus());
                }
            }),
            /*#__PURE__*/ _jsx("div", {
                className: bubble,
                onClick: ()=>{
                    setIsActive(!isActive);
                    setRenderedOnce(true);
                },
                onMouseEnter: ()=>setIsHover(true),
                onMouseLeave: ()=>setIsHover(false),
                children: icon === "custom" && useIcon && !useIsActive ? /*#__PURE__*/ _jsx("img", {
                    "aria-hidden": true,
                    alt: "icon",
                    src: isHover ? useHoverIcon || useIcon : useIcon
                }) : /*#__PURE__*/ _jsx(BannerStickyIcon, {
                    type: useIsActive ? "close" : icon
                })
            }),
            /*#__PURE__*/ _jsx(AnimatedCss, {
                animationIn: "fadeInUp",
                animationInDuration: animationsEnabled ? 300 : 0,
                animationOut: "fadeOutDown",
                animationOutDuration: animationsEnabled ? 300 : 0,
                isVisible: useIsActive,
                className: menu,
                style: {
                    display: renderedOnce || previewStickyMenuOpenState ? undefined : "none"
                },
                children: renderedOnce && /*#__PURE__*/ _jsxs("ul", {
                    children: [
                        !!stickyHistory && /*#__PURE__*/ _jsx("li", {
                            children: /*#__PURE__*/ _jsx("a", {
                                href: "#b",
                                ref: firstLinkRef,
                                onClick: (e)=>{
                                    openHistory(e);
                                    setIsActive(false);
                                },
                                children: stickyHistory
                            })
                        }),
                        !!stickyRevoke && /*#__PURE__*/ _jsx("li", {
                            children: /*#__PURE__*/ _jsxs("a", {
                                href: "#a",
                                onClick: (e)=>{
                                    revokeConsent(stickyRevokeSuccessMessage, e);
                                    setIsRevoked(true);
                                },
                                children: [
                                    stickyRevoke,
                                    isRevoked && /*#__PURE__*/ _jsxs(Fragment, {
                                        children: [
                                            "\xa0",
                                            /*#__PURE__*/ _jsx(AsciiSpinner, {})
                                        ]
                                    })
                                ]
                            })
                        }),
                        !!stickyChange && /*#__PURE__*/ _jsx("li", {
                            children: /*#__PURE__*/ _jsx("a", {
                                href: "#c",
                                onClick: (e)=>{
                                    openBanner(e);
                                    setIsActive(false);
                                },
                                children: stickyChange
                            })
                        })
                    ]
                })
            })
        ]
    });
};
export { BannerStickyBubble };
